import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Dimbot is a puzzle game based on`}
      {" "}
      {` `}
      <a href="http://lightbot.com/" target="_blank">{` Lightbot`}</a>
      {`. It is written using the MEAN stack (MongoDB, AngularJS, Express.js and Node.js), and uses `}
      <a href="https://github.com/mrdoob/three.js/" target="_blank">{` `}
        {" "}
        {` three.js `}</a>
      {" "}
      {` for the 3D graphics. The source code can be found`}
      {" "}
      {` `}
      <a href="https://github.com/simonrose121/dimbot">{`here`}</a>
      {`.`}</p>
    <p>{`The game was used to conduct a research study for my Masters investigating the effects of visual programming environments on problem solving ability in young children (age 6 and 7). It has 2 different versions: one for ScratchJr-like (block-based) instructions and one for the Lightbot instruction approach. The key difference between the two is that ScratchJr-like instructions can be added to the program but are not executed unless attached to a 'start' block, whereas all the instructions in the Lightbot style program are executed.`}</p>
    <p>{`A conference paper describing this application and the research study it was used in was presented at the `}
      <a href="https://pdfs.semanticscholar.org/0868/960977cf6c6dc7132be20b6f5a6d7ee1649d.pdf" target="_blank">{`10th European Conference for Game Based Learning`}</a>
      {`. A follow up article was published in the `}
      <a href="http://shura.shu.ac.uk/16235/8/Rose-Explorationoftheroleofvisualprogramming%28VoR%29.pdf" target="_blank">{`Electronic Journal of E-Learning`}</a>
      {`.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      